import { createFileRoute, redirect } from "@tanstack/react-router";
import { useAuthStore } from "~/app/stores/auth";

export const Route = createFileRoute("/leaderboards")({
  beforeLoad: () => {
    const state = useAuthStore.getState();
    // TODO: REMOVE MOCK
    const isAuthenticated = true; //state.isAuthenticated;
    const setModelOpenNotLogged = state.setModelOpenNotLogged;

    if (!isAuthenticated) {
      setModelOpenNotLogged(true);

      throw redirect({
        to: "/home",
      });
    }
    return true;
  },
});
